import React from "react";
import { FiMaximize2, FiCopy } from "react-icons/fi";
import { FaSync, FaPlus, FaTrash } from "react-icons/fa";

const ParagraphTabMenu = ({ darkMode, mode, onModeChange }) => {
  const tabs = [
    { id: "rewrite", label: "Rewrite", icon: <FaSync size={16} /> },
    { id: "insert", label: "Insert", icon: <FaPlus size={16} /> },
    { id: "expand", label: "Expand", icon: <FiMaximize2 size={16} /> },
  ];

  const actionButtons = [
    { id: "copy", label: "Copy", icon: <FiCopy size={16} /> },
    {
      id: "delete",
      label: "Delete",
      icon: <FaTrash size={16} />,
      isDanger: true,
    },
  ];

  return (
    <div
      className={`w-full border-b ${
        darkMode ? "border-gray-700" : "border-gray-200"
      }`}
    >
      <div className="flex justify-between items-center">
        <div className="flex space-x-1">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => onModeChange(tab.id)}
              title={tab.label}
              className={`
                px-4 py-2 text-sm font-medium rounded-t-lg transition-all duration-200
                flex items-center gap-2 min-w-[48px] justify-center
                ${
                  mode === tab.id
                    ? darkMode
                      ? "bg-yellow-500 text-white w-auto"
                      : "bg-yellow-400 text-white w-auto"
                    : darkMode
                    ? "text-gray-400 hover:text-gray-200 hover:bg-gray-800"
                    : "text-gray-600 hover:text-gray-800 hover:bg-gray-100"
                }
              `}
            >
              {tab.icon}
              {mode === tab.id && <span>{tab.label}</span>}
            </button>
          ))}
        </div>
        <div className="flex space-x-1 pr-2">
          {actionButtons.map((button) => (
            <button
              key={button.id}
              onClick={() => onModeChange(button.id)}
              title={button.label}
              className={`
                p-2 text-sm font-medium rounded-lg transition-colors duration-200
                flex items-center justify-center
                ${
                  button.isDanger
                    ? darkMode
                      ? "text-red-400 hover:text-red-300 hover:bg-red-900/20"
                      : "text-red-600 hover:text-red-700 hover:bg-red-50"
                    : darkMode
                    ? "text-gray-400 hover:text-gray-200 hover:bg-gray-800"
                    : "text-gray-600 hover:text-gray-800 hover:bg-gray-100"
                }
              `}
            >
              {button.icon}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ParagraphTabMenu;
